// Enhanced Lightbox with comprehensive debugging
// CHANGED: Updated from Glide to Swiper selectors (gallery was migrated Glide -> Swiper
// but this lightbox was never updated, so it never initialized). All functional changes
// are marked with "// CHANGED:" so they can be reviewed / reverted easily.
(function () {
  "use strict";

  console.log("🔍 Lightbox script loading...");

  let lightboxInitialized = false;
  let lightboxOverlay = null;
  let lightboxImage = null;
  let lightboxClose = null;
  let lightboxPrev = null;
  let lightboxNext = null;
  let lightboxCounter = null;
  let lightboxAltText = null;
  let currentImageIndex = 0;
  let allImages = [];

  // Debug function to log gallery state
  function debugGalleryState() {
    console.log("📊 Gallery Debug Info:");
    console.log(
      "- Gallery images found:",
      document.querySelectorAll(".product-gallery-image").length
    );
    console.log(
      "- Active slide:",
      // CHANGED: .glide__slide--active -> .swiper-slide-active
      document.querySelector(".swiper-slide-active") ? "Found" : "Not found"
    );
    console.log("- Lightbox overlay:", lightboxOverlay ? "Found" : "Not found");
    console.log(
      // CHANGED: window.productGlide -> window.productSwiper
      "- Swiper instance:",
      window.productSwiper ? "Available" : "Not available"
    );

    // CHANGED: .glide__slide--active -> .swiper-slide-active
    const activeSlide = document.querySelector(".swiper-slide-active");
    if (activeSlide) {
      const activeImage = activeSlide.querySelector(".product-gallery-image");
      console.log(
        "- Active image:",
        activeImage ? activeImage.src : "No image in active slide"
      );
    }
  }

  // Check if device is mobile
  function isMobileDevice() {
    return window.innerWidth <= 768 ||
           /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  // Function to initialize lightbox elements
  function initializeLightboxElements() {
    // Skip initialization on mobile devices
    if (isMobileDevice()) {
      console.log("📱 Mobile device detected - lightbox disabled");
      return false;
    }

    console.log("🔧 Initializing lightbox elements...");

    lightboxOverlay = document.getElementById("lightbox-overlay");
    lightboxImage = document.getElementById("lightbox-image");
    lightboxClose = document.getElementById("lightbox-close");
    lightboxPrev = document.getElementById("lightbox-prev");
    lightboxNext = document.getElementById("lightbox-next");
    lightboxCounter = document.getElementById("lightbox-counter");
    lightboxAltText = document.getElementById("lightbox-alt-text");

    if (
      !lightboxOverlay ||
      !lightboxImage ||
      !lightboxClose ||
      !lightboxPrev ||
      !lightboxNext ||
      !lightboxCounter ||
      !lightboxAltText
    ) {
      console.error("❌ Lightbox elements not found:", {
        overlay: !!lightboxOverlay,
        image: !!lightboxImage,
        close: !!lightboxClose,
        prev: !!lightboxPrev,
        next: !!lightboxNext,
        counter: !!lightboxCounter,
        altText: !!lightboxAltText,
      });
      return false;
    }

    console.log("✅ All lightbox elements found");
    return true;
  }

  // Function to get all gallery images
  function getAllGalleryImages() {
    // CHANGED: exclude Swiper's duplicated slides if looping is ever enabled.
    // (Currently loop:false, so this is a harmless safeguard.)
    return Array.from(
      document.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate) .product-gallery-image"
      )
    );
  }

  // Function to find current image index
  function findCurrentImageIndex(imageSrc) {
    return allImages.findIndex((img) => img.src === imageSrc);
  }

  // Function to get full-size image URL from srcset or src
  function getFullSizeImageUrl(image) {
    // Try to get the largest image from srcset
    if (image.srcset) {
      const srcsetEntries = image.srcset.split(",").map((entry) => {
        const parts = entry.trim().split(" ");
        const url = parts[0];
        const width = parts[1] ? parseInt(parts[1].replace("w", "")) : 0;
        return { url, width };
      });

      // Sort by width descending and get the largest
      srcsetEntries.sort((a, b) => b.width - a.width);
      if (srcsetEntries.length > 0 && srcsetEntries[0].width > 0) {
        console.log(`📸 Using full-size image: ${srcsetEntries[0].width}w`);
        return srcsetEntries[0].url;
      }
    }

    // Fallback to regular src, but try to get a larger version
    let fullSizeUrl = image.src;

    // If it's a Shopify image URL, try to get the original size
    if (fullSizeUrl.includes("cdn.shopify.com") && fullSizeUrl.includes("_")) {
      // Remove size parameters to get original
      fullSizeUrl = fullSizeUrl.replace(/_\d+x\d*(@\d+x)?\./, ".");
      console.log(`📸 Using original Shopify image URL`);
    }

    return fullSizeUrl;
  }

  // Function to update lightbox image
  function updateLightboxImage(index) {
    if (index < 0 || index >= allImages.length) {
      console.error("❌ Invalid image index:", index);
      return;
    }

    currentImageIndex = index;
    const currentImage = allImages[index];

    // Get the full-size image URL
    const fullSizeUrl = getFullSizeImageUrl(currentImage);

    lightboxImage.src = fullSizeUrl;
    lightboxImage.alt = currentImage.alt || `Product image ${index + 1}`;

    // Update counter
    if (lightboxCounter) {
      lightboxCounter.textContent = `${index + 1} / ${allImages.length}`;
    }

    // Update alt text in footer
    if (lightboxAltText) {
      const altText = currentImage.alt || `Product image ${index + 1}`;
      lightboxAltText.textContent = altText;
    }

    // Update navigation button states
    if (lightboxPrev) {
      lightboxPrev.disabled = index === 0;
    }
    if (lightboxNext) {
      lightboxNext.disabled = index === allImages.length - 1;
    }

    console.log(
      `✅ Updated to image ${index + 1}/${allImages.length}:`,
      fullSizeUrl
    );
  }

  // Function to navigate to previous image
  function navigatePrevious() {
    if (currentImageIndex > 0) {
      updateLightboxImage(currentImageIndex - 1);
    }
  }

  // Function to navigate to next image
  function navigateNext() {
    if (currentImageIndex < allImages.length - 1) {
      updateLightboxImage(currentImageIndex + 1);
    }
  }

  // Function to open lightbox with current active image
  function openLightbox() {
    console.log("🖼️ Opening lightbox...");

    if (!lightboxOverlay || !lightboxImage) {
      console.error("❌ Lightbox elements not available");
      return;
    }

    // Get all gallery images
    allImages = getAllGalleryImages();
    if (allImages.length === 0) {
      console.error("❌ No gallery images found");
      return;
    }

    // CHANGED: prefer the Swiper instance's activeIndex (reliable), fall back to DOM.
    let startIndex = 0;
    if (window.productSwiper && typeof window.productSwiper.activeIndex === "number") {
      startIndex = window.productSwiper.activeIndex;
    } else {
      // CHANGED: .glide__slide--active -> .swiper-slide-active
      const activeSlide = document.querySelector(".swiper-slide-active");
      if (activeSlide) {
        const activeImage = activeSlide.querySelector(".product-gallery-image");
        if (activeImage) {
          const found = findCurrentImageIndex(activeImage.src);
          if (found !== -1) startIndex = found;
        }
      }
    }

    // Clamp just in case
    if (startIndex < 0 || startIndex >= allImages.length) {
      console.warn("⚠️ Active index out of range, defaulting to first image");
      startIndex = 0;
    }

    currentImageIndex = startIndex;

    console.log(`✅ Opening lightbox at image ${currentImageIndex + 1}/${allImages.length}`);

    // Show lightbox
    lightboxOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
    document.body.classList.add("lightbox-open");

    // Update the image and navigation
    updateLightboxImage(currentImageIndex);

    console.log("✅ Lightbox opened successfully");
  }

  // Function to close lightbox
  function closeLightbox() {
    console.log("❌ Closing lightbox...");

    if (lightboxOverlay) {
      lightboxOverlay.classList.remove("active");
    }
    document.body.style.overflow = "";
    document.body.classList.remove("lightbox-open");

    console.log("✅ Lightbox closed");
  }

  // Handle image click with comprehensive event handling
  function handleImageClick(e) {
    // Skip on mobile devices
    if (isMobileDevice()) {
      console.log("📱 Mobile device - lightbox disabled");
      return;
    }

    console.log("🖱️ Image clicked:", e.target.src);

    // Prevent any default behavior and stop propagation
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Small delay to ensure any gallery transitions are complete
    setTimeout(() => {
      openLightbox();
    }, 50);
  }

  // Add click events to gallery images with multiple strategies
  function addLightboxEvents() {
    // Skip event attachment on mobile devices
    if (isMobileDevice()) {
      console.log("📱 Mobile device detected - skipping lightbox events");
      // Remove pointer cursor on mobile
      const galleryImages = document.querySelectorAll(".product-gallery-image");
      galleryImages.forEach(function (image) {
        image.style.cursor = "default";
        image.style.pointerEvents = "none";
      });
      return;
    }

    console.log("🔗 Adding lightbox events...");

    const galleryImages = document.querySelectorAll(".product-gallery-image");
    console.log(`Found ${galleryImages.length} gallery images`);

    if (galleryImages.length === 0) {
      console.warn("⚠️ No gallery images found to attach events to");
      return;
    }

    galleryImages.forEach(function (image, index) {
      console.log(`Adding events to image ${index + 1}:`, image.src);

      // Remove any existing listeners first
      image.removeEventListener("click", handleImageClick);
      image.removeEventListener("mousedown", handleImageClick);
      image.removeEventListener("touchstart", handleImageClick);

      // Add multiple event types for better compatibility
      image.addEventListener("click", handleImageClick, { capture: true });
      image.addEventListener("mousedown", handleImageClick, { capture: true });
      image.addEventListener("touchstart", handleImageClick, {
        capture: true,
        passive: false,
      });

      // Ensure the image has pointer cursor
      image.style.cursor = "pointer";
      image.style.pointerEvents = "auto";

      console.log(`✅ Events added to image ${index + 1}`);
    });

    console.log("✅ All lightbox events added");
  }

  // Setup lightbox close and navigation events
  function setupCloseEvents() {
    console.log("🔗 Setting up close and navigation events...");

    // Close lightbox when clicking overlay
    if (lightboxOverlay) {
      lightboxOverlay.addEventListener("click", function (e) {
        if (e.target === lightboxOverlay) {
          console.log("🖱️ Overlay clicked - closing lightbox");
          closeLightbox();
        }
      });
    }

    // Close lightbox when clicking close button
    if (lightboxClose) {
      lightboxClose.addEventListener("click", function (e) {
        console.log("🖱️ Close button clicked");
        e.preventDefault();
        e.stopPropagation();
        closeLightbox();
      });
    }

    // Previous image navigation
    if (lightboxPrev) {
      lightboxPrev.addEventListener("click", function (e) {
        console.log("🖱️ Previous button clicked");
        e.preventDefault();
        e.stopPropagation();
        navigatePrevious();
      });
    }

    // Next image navigation
    if (lightboxNext) {
      lightboxNext.addEventListener("click", function (e) {
        console.log("🖱️ Next button clicked");
        e.preventDefault();
        e.stopPropagation();
        navigateNext();
      });
    }

    // Keyboard navigation
    document.addEventListener("keydown", function (e) {
      if (lightboxOverlay && lightboxOverlay.classList.contains("active")) {
        switch (e.key) {
          case "Escape":
            console.log("⌨️ Escape key pressed - closing lightbox");
            closeLightbox();
            break;
          case "ArrowLeft":
            console.log("⌨️ Left arrow pressed - previous image");
            e.preventDefault();
            navigatePrevious();
            break;
          case "ArrowRight":
            console.log("⌨️ Right arrow pressed - next image");
            e.preventDefault();
            navigateNext();
            break;
        }
      }
    });

    console.log("✅ Close and navigation events setup complete");
  }

  // Main initialization function
  function initializeLightbox() {
    console.log("🚀 Initializing lightbox...");

    if (lightboxInitialized) {
      console.log("⚠️ Lightbox already initialized");
      return;
    }

    // Debug current state
    debugGalleryState();

    // Initialize elements
    if (!initializeLightboxElements()) {
      console.error("❌ Failed to initialize lightbox elements");
      return;
    }

    // Setup close events
    setupCloseEvents();

    // Add events to images
    addLightboxEvents();

    // Set up mutation observer for dynamic content
    const observer = new MutationObserver(function (mutations) {
      let shouldReinitialize = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          // Check if new images were added
          const addedNodes = Array.from(mutation.addedNodes);
          const hasNewImages = addedNodes.some(
            (node) =>
              node.nodeType === 1 &&
              (node.classList?.contains("product-gallery-image") ||
                node.querySelector?.(".product-gallery-image"))
          );

          if (hasNewImages) {
            console.log("🔄 New images detected, reinitializing events...");
            shouldReinitialize = true;
          }
        }
      });

      if (shouldReinitialize) {
        setTimeout(() => {
          addLightboxEvents();
        }, 100);
      }
    });

    // Observe the gallery container
    // CHANGED: .glide__slides -> .swiper-wrapper
    const galleryContainer = document.querySelector(".product-swiper .swiper-wrapper");
    if (galleryContainer) {
      observer.observe(galleryContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
      console.log("✅ Mutation observer setup for gallery container");
    } else {
      console.warn("⚠️ Gallery container not found for mutation observer");
    }

    lightboxInitialized = true;
    console.log("✅ Lightbox initialization complete");

    // Add global debug functions
    window.debugLightbox = function () {
      console.log("🔍 Manual lightbox debug:");
      debugGalleryState();

      console.log("🧪 Testing lightbox open...");
      openLightbox();
    };

    window.testLightboxClick = function () {
      console.log("🧪 Testing image click simulation...");
      const firstImage = document.querySelector(".product-gallery-image");
      if (firstImage) {
        console.log("Simulating click on:", firstImage.src);
        handleImageClick({
          target: firstImage,
          preventDefault: () => {},
          stopPropagation: () => {},
          stopImmediatePropagation: () => {},
        });
      } else {
        console.error("No images found to test");
      }
    };

    console.log("🛠️ Debug functions available:");
    console.log("- window.debugLightbox() - Debug lightbox state");
    console.log("- window.testLightboxClick() - Test image click");
  }

  // Multiple initialization strategies
  function attemptInitialization() {
    // Skip initialization on mobile devices
    if (isMobileDevice()) {
      console.log("📱 Mobile device detected - lightbox disabled");
      return false;
    }

    console.log("🔄 Attempting lightbox initialization...");

    // Strategy 1: Check if DOM is ready and gallery exists
    // CHANGED: .product-glide -> .product-swiper  (THIS is the change that unblocks init)
    const galleryExists = document.querySelector(".product-swiper");
    const lightboxExists = document.querySelector("#lightbox-overlay");

    if (galleryExists && lightboxExists) {
      console.log("✅ Gallery and lightbox elements found, initializing...");
      initializeLightbox();
      return true;
    }

    console.log("⚠️ Gallery or lightbox elements not ready yet");
    return false;
  }

  // Try initialization on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      console.log("📄 DOM Content Loaded");
      setTimeout(attemptInitialization, 100);
    });
  } else {
    console.log("📄 DOM already ready");
    setTimeout(attemptInitialization, 100);
  }

  // Fallback: Try initialization after a delay
  setTimeout(function () {
    if (!lightboxInitialized) {
      console.log("🔄 Fallback initialization attempt...");
      attemptInitialization();
    }
  }, 1000);

  // Another fallback for when Swiper is ready
  // CHANGED: window.productGlide -> window.productSwiper
  setTimeout(function () {
    if (!lightboxInitialized && window.productSwiper) {
      console.log("🔄 Swiper-ready initialization attempt...");
      attemptInitialization();
    }
  }, 2000);

  console.log("🔍 Lightbox script loaded and ready");
})();